import { render, staticRenderFns } from "./BlockPopupMatchCustomer.vue?vue&type=template&id=1b37924e&scoped=true&"
import script from "./BlockPopupMatchCustomer.vue?vue&type=script&lang=js&"
export * from "./BlockPopupMatchCustomer.vue?vue&type=script&lang=js&"
import style0 from "./BlockPopupMatchCustomer.vue?vue&type=style&index=0&id=1b37924e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37924e",
  null
  
)

export default component.exports